export const signableForm = `<svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="2 2 20 20" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor">
  <path d="M10 12h-1v5h1"/>
  <path d="M14 12h1v5h-1"/>
  <path d="M14 3v4a1 1 0 0 0 1 1h4"/>
  <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"/>
</svg>`;